'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterDom = require('react-router-dom');

var _reactRhumb = require('react-rhumb');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UICheckbox = require('UIComponents/input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _colors = require('HubStyleTokens/colors');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _UpgradeProducts = require('self-service-api/constants/UpgradeProducts');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _MerchandiseIdsToUpgradeProducts = require('self-service-api/constants/MerchandiseIdsToUpgradeProducts');

var _UICheckoutButton = require('ui-addon-upgrades/button/UICheckoutButton');

var _UICheckoutButton2 = _interopRequireDefault(_UICheckoutButton);

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _ContactsPicker = require('pricing-pages-unified-ui/components/common/ContactsPicker');

var _ContactsPicker2 = _interopRequireDefault(_ContactsPicker);

var _ContactsSelectors = require('pricing-pages-unified-ui/selectors/ContactsSelectors');

var _itemConfigUtils = require('../../utils/itemConfigUtils');

var _urls = require('../../utils/urls');

var _hasBackdoor = require('../../utils/hasBackdoor');

var _hasBackdoor2 = _interopRequireDefault(_hasBackdoor);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _ItemConfigsSelectors = require('pricing-pages-unified-ui/selectors/ItemConfigsSelectors');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _merchandiseUtils = require('pricing-pages-unified-ui/utils/merchandiseUtils');

var _Terms = require('self-service-api/constants/Terms');

var _DocumentUtils = require('pricing-pages-unified-ui/static/js/utils/DocumentUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataBox = (0, _styledComponents2.default)(_UIBox2.default).withConfig({
  displayName: 'ContactsConfirmationPage__DataBox'
})(['&:nth-child(2){border-left:solid 1px ', ';border-right:solid 1px ', ';}'], _colors.BATTLESHIP, _colors.BATTLESHIP);

var DataWell = function DataWell(_ref) {
  var data = _ref.data,
      label = _ref.label,
      body = _ref.body;
  return _react2.default.createElement(
    DataBox,
    { grow: 1, basis: '33%', className: 'p-all-6' },
    _react2.default.createElement(
      'h3',
      { className: 'm-bottom-1' },
      data
    ),
    _react2.default.createElement(
      'p',
      { className: 'm-bottom-2' },
      label
    ),
    _react2.default.createElement(
      _Small2.default,
      { use: 'help' },
      body
    )
  );
};

var ContactsConfirmationPage = function (_React$Component) {
  _inherits(ContactsConfirmationPage, _React$Component);

  function ContactsConfirmationPage(props) {
    _classCallCheck(this, ContactsConfirmationPage);

    var _this = _possibleConstructorReturn(this, (ContactsConfirmationPage.__proto__ || Object.getPrototypeOf(ContactsConfirmationPage)).call(this, props));

    _this.handleConfirm = function (e) {
      e.stopPropagation();
      _this.setState(function (prevState) {
        return { confirmed: !prevState.confirmed };
      });
    };

    _this.state = _extends({
      confirmed: false
    }, props.location.state);
    return _this;
  }

  _createClass(ContactsConfirmationPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          merchandiseId = _props.merchandiseId,
          minPurchasableContacts = _props.minPurchasableContacts,
          availableTerms = _props.availableTerms,
          history = _props.history;
      var _state = this.state,
          additionalUnitQuantity = _state.additionalUnitQuantity,
          term = _state.term;


      if (!merchandiseId) {
        history.replace({ pathname: (0, _urls.getProductTabUrl)(_ProductsAndPlansNavIds.MARKETING) });
        return;
      }

      if (!additionalUnitQuantity) {
        this.setState({ additionalUnitQuantity: minPurchasableContacts });
      }

      if (!term || !availableTerms[term]) {
        var defaultTerm = availableTerms.monthly ? _Terms.MONTHLY : _Terms.ANNUAL;
        this.setState({ term: defaultTerm });
      }
    }
  }, {
    key: 'getItemConfigs',
    value: function getItemConfigs() {
      var _props2 = this.props,
          merchandiseId = _props2.merchandiseId,
          requiredOnboarding = _props2.pricingDependencies.requiredOnboarding;
      var _state2 = this.state,
          additionalUnitQuantity = _state2.additionalUnitQuantity,
          ownsProduct = _state2.ownsProduct;


      var itemConfigurations = [];
      if (ownsProduct) {
        itemConfigurations.push((0, _itemConfigUtils.createAdditionalUnitsItemConfig)({
          merchandiseId: merchandiseId,
          additionalUnitQuantity: additionalUnitQuantity
        }));
      } else {
        itemConfigurations = (0, _itemConfigUtils.createItemConfigWithMandatoryMerch)({
          merchandiseId: merchandiseId,
          additionalUnitQuantity: additionalUnitQuantity,
          requiredOnboarding: requiredOnboarding
        });
      }
      return itemConfigurations;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          merchandiseId = _props3.merchandiseId,
          minPurchasableContacts = _props3.minPurchasableContacts,
          emailSendMultiplier = _props3.emailSendMultiplier,
          pricingDependencies = _props3.pricingDependencies,
          availableTerms = _props3.availableTerms;
      var _state3 = this.state,
          confirmed = _state3.confirmed,
          additionalUnitQuantity = _state3.additionalUnitQuantity,
          term = _state3.term,
          ownsProduct = _state3.ownsProduct;


      if (!merchandiseId || !additionalUnitQuantity || !term) return null;

      var includedContacts = (0, _merchandiseUtils.includedAdditionalUnits)(merchandiseId);

      var isMarketingStarter = merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL;
      var isBuyingAdditionalContacts = additionalUnitQuantity > minPurchasableContacts;

      var productName = _ImmutableMerchandiseIdMap2.default[merchandiseId].productName;
      var itemConfigurations = this.getItemConfigs();

      var pricingInfo = (0, _pricingUtils.calculatePrice)(_extends({}, pricingDependencies, {
        merchandiseId: merchandiseId,
        term: term,
        itemConfigurations: itemConfigurations
      }));

      var updateNumContacts = function updateNumContacts(numExtraContacts) {
        var numTotalContacts = includedContacts + numExtraContacts;
        _this2.setState({
          additionalUnitQuantity: numTotalContacts
        });
      };

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_reactRhumb.NavMarker, { name: 'CONTACTS_CONFIRMATION_PAGE' }),
        _react2.default.createElement(
          'div',
          {
            className: 'm-x-auto m-bottom-10 p-top-12',
            style: { maxWidth: '850px' }
          },
          _react2.default.createElement(
            'h2',
            { className: 'text-center m-bottom-10' },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.title' })
          ),
          _react2.default.createElement(
            _UITile2.default,
            { className: 'p-all-10' },
            _react2.default.createElement(
              _UIFlex2.default,
              { className: 'text-center' },
              _react2.default.createElement(DataWell, {
                data: _react2.default.createElement(_FormattedNumber2.default, { value: additionalUnitQuantity }),
                label: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contacts.title' }),
                body: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.contacts.text' })
              }),
              _react2.default.createElement(DataWell, {
                data: _react2.default.createElement(_FormattedNumber2.default, {
                  value: additionalUnitQuantity * emailSendMultiplier
                }),
                label: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.emailSends.title' }),
                body: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.emailSends.text' })
              }),
              _react2.default.createElement(DataWell, {
                data: _react2.default.createElement(_PriceDisplay2.default, {
                  price: pricingInfo.monthly.calculatedPrice,
                  currencyCode: pricingDependencies.currencyCode
                }),
                label: _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.perMonthExtended' }),
                body: _react2.default.createElement(_FormattedMessage2.default, {
                  message: 'contactConfirmation.pricing.text',
                  options: {
                    numberOfContacts: additionalUnitQuantity,
                    productName: productName
                  }
                })
              })
            ),
            _react2.default.createElement(_ContactsPicker2.default, {
              merchandiseId: merchandiseId,
              additionalUnitQuantity: additionalUnitQuantity - includedContacts,
              onChange: updateNumContacts,
              term: term
            })
          ),
          isMarketingStarter && _react2.default.createElement(
            _UISelectableBox2.default,
            {
              selected: confirmed,
              onSelectedChange: this.handleConfirm,
              className: 'text-left p-top-6 m-top-6'
            },
            _react2.default.createElement(
              'h5',
              { className: 'm-bottom-3' },
              _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.confirmationBoxTitle' })
            ),
            _react2.default.createElement(
              'p',
              { style: { fontWeight: 'normal' } },
              _react2.default.createElement(_FormattedMessage2.default, {
                message: 'contactConfirmation.confirmationBoxBody',
                options: { productName: productName }
              })
            ),
            _react2.default.createElement(
              _UICheckbox2.default,
              {
                checked: confirmed,
                onChange: this.handleConfirm,
                'data-selenium-id': 'contact-tier-accept-terms-button'
              },
              _react2.default.createElement(_FormattedMessage2.default, {
                message: 'contactConfirmation.confirmationBoxCheckbox',
                style: { fontWeight: 600 }
              })
            )
          ),
          _react2.default.createElement(
            _UICheckoutButton2.default,
            {
              className: 'm-top-6',
              disabled: !confirmed && isMarketingStarter || !isBuyingAdditionalContacts && ownsProduct,
              upgradeData: {
                app: _Tracking.APP,
                screen: _Tracking.SCREENS.CONTACT_CONFIRMATION,
                upgradeProduct: _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId],
                uniqueId: _Tracking.SCREENS.CONTACT_CONFIRMATION
              },
              use: 'primary',
              itemConfigurations: itemConfigurations,
              currencyCode: pricingDependencies.currencyCode,
              termId: availableTerms[term],
              style: { marginLeft: 0 },
              additionalUnitQuantity: additionalUnitQuantity,
              'data-selenium-id': merchandiseId + '-checkout-contacts-button'
            },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'contactConfirmation.continue' })
          )
        )
      );
    }
  }]);

  return ContactsConfirmationPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var location = _ref2.location;

  var hasMarketingStarterBackdoor = (0, _hasBackdoor2.default)(_UpgradeProducts.MARKETING_STARTER, location.search);

  var merchandiseId = location.state && location.state.merchandiseId;
  var isLoadingPurchaseMotions = state.purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED;

  if (hasMarketingStarterBackdoor) {
    merchandiseId = _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL;
  }

  if (!merchandiseId || isLoadingPurchaseMotions) return {};

  return {
    merchandiseId: merchandiseId,
    availableTerms: (0, _ItemConfigsSelectors.availableTermsForMerchSelector)(state, merchandiseId),
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state),
    emailSendMultiplier: (0, _ContactsSelectors.emailSendMultiplierSelector)(state, merchandiseId),
    minPurchasableContacts: (0, _ContactsSelectors.minPurchasableContactsSelector)(state, merchandiseId)
  };
};

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(ContactsConfirmationPage, 'marketing')));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/contacts-confirmation-page/ContactsConfirmationPage.js
// module id = 721
// module chunks = 3 4